import $ from "jquery";
import axios from "axios";
import {isMobile} from "Core/screenSizes";

export const eventAds = () => {
    const element = $(".material-content__right-part");

    axios.get(element.data('url'), {
        params: {
            isMobile: isMobile()
        }
    })
        .then((response) => {
            element.prepend(response.data);
        });
};
